import GameSprite from "../components/GameSprite";
import PhysicsSystem from "./PhysicsSystem";
import C_Entity from "../../const/C_Entity";
class EntitySystem
{


    constructor()
    {
        this.app = PIXI.app;

        this.entities = {};
        this.entitiesByType = {};
        this.updatedComponents = [];
        this.postPhysicsUpdatedComponents = [];

        this.addQueue = [];
        this.removeQueue = [];

        this.physicsSys = new PhysicsSystem();

        this.baseTimeScale = 4;

        this.diaTime = 2;
    }


    setMainView(mainView)
    {
        this.mainView = mainView;
    }


    addEntity(e)
    {
        let eId = e.getId();
        let eType = e.getType();
        this.entities[eId] = e;

        let ebt = this.entitiesByType[eType];
        if (!ebt)
        {
            ebt = {};
            this.entitiesByType[eType] = ebt;
        }
        ebt[eId] = e;

        let gameSprite = e.getComponent(GameSprite);

        if (gameSprite && gameSprite.sprite)
        {
            this.mainView.mainContainer.addChild(gameSprite.sprite);
        }

        for (let compType in e.components)
        {
            let comp = e.components[compType];
            comp.init();

            if (comp.update)
            {
                this.updatedComponents.push(comp);
            }

            if (comp.postPhysicsUpdate)
            {
                this.postPhysicsUpdatedComponents.push(comp);
            }

            if (comp.physicsType)
            {
                this.physicsSys.add(comp);
            }
        }
    }


    removeEntity(e)
    {
        let gameSprite = e.getComponent(GameSprite);
        if (gameSprite)
        {
            let s = gameSprite.sprite;
            if (s && s.parent)
            {
                s.parent.removeChild(s);
            }
        }


        for (let compType in e.components)
        {
            let comp = e.components[compType];

            if (comp.update)
            {
                let idx = this.updatedComponents.indexOf(comp);
                if (idx != -1)
                {
                    this.updatedComponents.splice(idx, 1);
                }
            }

            if (comp.postPhysicsUpdate)
            {
                let idx = this.postPhysicsUpdatedComponents.indexOf(comp);
                if (idx != -1)
                {
                    this.postPhysicsUpdatedComponents.splice(idx, 1);
                }
            }

            if (comp.physicsType)
            {
                this.physicsSys.remove(comp);
            }

            comp.destroy();
        }

        e.isRemoved = true;
        let eId = e.getId();
        let eType = e.getType();

        delete this.entities[eId];
        delete this.entitiesByType[eType][eId];
    }


    start()
    {
        this.updateTween = TweenMax.to(this, 1000000, {onUpdate:this.update, onUpdateScope:this});
        this.currTime = this.updateTween.time();
    }


    setTimeScale(scale)
    {
        this.baseTimeScale = scale;
    }


    update()
    {
        this.mainView.mainContainer.children.sort(this.zSort);

        let d = new Date();
        let startTime = d.getTime();

        let newTime = this.updateTween.time();
        let deltaSec = (newTime - this.currTime) * this.baseTimeScale;
        this.currTime = newTime;

        if (this.app.model.getPause())
        {
            return;
        }

        while (this.addQueue.length > 0)
        {
            this.addEntity(this.addQueue.pop());
        }

        let numUpdated = this.updatedComponents.length;
        for (let updIdx=0; updIdx < numUpdated; updIdx++)
        {
            let updatedComp = this.updatedComponents[updIdx];
            updatedComp.update(deltaSec);

            let e = updatedComp.entity;
            if (e.queueForRemoval)
            {
                this.removeQueue.push(e);
            }
        }

        this.physicsSys.run();

        numUpdated = this.postPhysicsUpdatedComponents.length;
        for (let updIdx=0; updIdx < numUpdated; updIdx++)
        {
            let updatedComp = this.postPhysicsUpdatedComponents[updIdx];
            updatedComp.postPhysicsUpdate(deltaSec);

            let e = updatedComp.entity;
            if (e.queueForRemoval)
            {
                this.removeQueue.push(e);
            }
        }

        while (this.removeQueue.length > 0)
        {
            this.removeEntity(this.removeQueue.pop());
        }

        // d = new Date();
        // console.log("Main loop time : " + (d.getTime() - startTime) + "ms" );
        // this.runDiag(deltaSec);
    }


    runDiag(delta)
    {
        this.diaTime -= delta;
        if (this.diaTime > 0)
        {
            return;
        }
        else
        {
            this.diaTime = 4;
        }
        console.log("-------------------------------------------------------------------");
        // console.log("Updated comps : " + this.updatedComponents.length);
        // console.log("Post physics updated comps : " + this.postPhysicsUpdatedComponents.length);

        let cnt = 0;

        // let entities = this.entities;
        let entities = this.getEntitiesByType(C_Entity.WEAPON_PROJECTILE);
        for (let e in entities)
        {
            cnt++;
        }

        console.log("Num entities : " + cnt);

        // console.log("Physics active : " + this.physicsSys.active.length);
        // console.log("Physics passive : " + this.physicsSys.passive.length);
        //
        // console.log("Tweens : " + TweenMax.getAllTweens().length);

        // this.app.nav.runDiag();
    }


    zSort(child1, child2)
    {
        return  (child2.sortZ >= child1.sortZ) ? 1 : -1;
    }


    queueEntityToAdd(e)
    {
        this.addQueue.push(e);
    }


    getEntitiesByType(type)
    {
        return this.entitiesByType[type];
    }


    getEntityById(id)
    {
        return this.entities[id];
    }


    getBotEntityById(botId)
    {
        let bots = this.getEntitiesByType(C_Entity.FRIENDLY_BOT);

        let e;
        for (let bot in bots)
        {
            e = bots[bot];
            if (e.botId == botId)
            {
                break;
            }
        }

        return e;
    }


    stopSystem()
    {
        this.updateTween.kill();

        let allEntities = {};
        allEntities = this.entities;

        for (let key in allEntities)
        {
            this.removeEntity(this.entities[key]);
        }

        allEntities = null;

        this.entities = [];
        this.entitiesByType = {};
        this.updatedComponents = [];
        this.postPhysicsUpdatedComponents = [];

        this.addQueue = [];
        this.removeQueue = [];
    }


}


export default EntitySystem;